export default class DropdownConfig {
  constructor(value, options = []) {
    this.value = value;
    this.options = options;
  }
}
